import FooterContact from './FooterContact';

export default FooterContact;
